import { useMutation } from "@tanstack/react-query";
import { deleteMatrixRow } from "@/domains/matrix";
import { useMatrixInvalidation } from "./use-matrix-invalidation";

// Deletes one or more rows (the backend route only takes a single id at a time).
export function useDeleteMatrixRows(collectionId: string) {
  const { invalidateDetailAndList } = useMatrixInvalidation(collectionId);

  return useMutation({
    mutationFn: (analysisIds: string[]) =>
      Promise.all(
        analysisIds.map((analysisId) =>
          deleteMatrixRow(collectionId, analysisId),
        ),
      ),
    onSuccess: invalidateDetailAndList,
  });
}
